import { CheckOutlined, CloseOutlined } from "@mui/icons-material";
import { Box, Fab, Grid, TextField } from "@mui/material";
import { useState } from "react";
import { ICandidateNote } from "../../../../App/Typings/CandidateProfile";

export function EditNote({
  cancelEditMode,
  note,
  saveEdit,
}: {
  cancelEditMode: (noteId: string) => void;
  note: ICandidateNote;
  saveEdit: (note: ICandidateNote) => void;
}) {
  const [editNoteValue, setEditNoteValue] = useState<string>();
  const [isNoteValid, setIsNoteValid] = useState<boolean>(true);
  const handleEditChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEditNoteValue(event.target.value);
    setIsNoteValid(event.target.value.length <= 1500 ? true : false);
  };
  const handleEditSave = () => {
    if (editNoteValue) {
      note.note = editNoteValue;
    }
    saveEdit(note);
  };
  return (
    <Box>
      <TextField
        id={`editnote-${note.id}`}
        data-test={`editnote-${note.id}`}
        multiline
        rows={5}
        sx={{ width: 1 }}
        onChange={handleEditChange}
        error={!isNoteValid}
        helperText={`${note.note.length}/1500`}
        defaultValue={note.note}
      />
      <Grid container justifyContent="flex-end">
        <Fab
          data-test={`editnote-save-${note.id}`}
          onClick={handleEditSave}
          sx={{
            backgroundColor: "primary.contrastText",
            color: "primary.main",
          }}
        >
          <CheckOutlined fontSize="small" />
        </Fab>
        &nbsp;
        <Fab
          data-test={`editnote-cancel-${note.id}`}
          onClick={() => cancelEditMode(note.id)}
          sx={{
            backgroundColor: "primary.contrastText",
            color: "error.main",
          }}
        >
          <CloseOutlined fontSize="small" />
        </Fab>
      </Grid>
    </Box>
  );
}
